export interface DownloadFileBase64 {
  filename: string;
  content: string;
  MimeType: string;
}
export interface DownloadFilesBase64 {
  files: DownloadFileBase64[];
}

export function downloadAll(files: DownloadFileBase64[]) {
  files.map((f, i) => {
    const blob = asBlob(f);
    setTimeout(() => download(f.filename, blob), i * 500);
  });
}

export function downloadFile(file: DownloadFileBase64) {
  const blob = asBlob(file);
  setTimeout(() => download(file.filename, blob), 0);
}

function asBlob(file: DownloadFileBase64) {
  let binary = b64toBlob(file.content, file.MimeType);
  return new Blob([binary], {
    type: file.MimeType
  });
}

function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

function download(filename, blob: Blob) {
  const objectUrl = URL.createObjectURL(blob);
  const downloadLink = document.createElement('a');
  downloadLink.href = objectUrl;
  downloadLink.download = filename;
  downloadLink.click();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000); // Clean up
}
